import React, { useState } from "react";
import styles from "./index.module.scss";
import { useFormik } from "formik";
import * as yup from "yup";
import { track } from "../../../utils/amplitude";
import Link from "next/link";

const InAppSubscriptionForm = () => {
  const [done, setDone] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
    },
    validateOnChange: false,
    validationSchema: yup.object({
      email: yup.string().email().required(),
      name: yup.string().required(),
      agreement: yup.boolean().oneOf([true], "Message"),
    }),
    onSubmit: (values) => {
      formik.resetForm();
      //alert(JSON.stringify(values));
      setDone(true);
      track("Lead form submission");
    },
  });
  return (
    <div className={styles.root}>
      <div className={styles.heading}>
        <h2>
          In-app subscription data
          <br /> doesn’t match?
        </h2>
        <p>
          Apphud provides real-time accurate data to grow your app revenue.
          <br />
          Book a demo to learn more about our platform.
        </p>
      </div>
      <div className={styles.content}>
        <form>
          <div className={styles.row}>
            <Link href="/demo" target="_blank">
              <button
                onClick={() => {
                  track("demo_request_link_clicked", { block: "top_link" });
                }}
                id="inApphudSubscriptionForm"
              >
                Get a demo
              </button>
            </Link>
          </div>
        </form>
        {/*<form onSubmit={formik.handleSubmit}>
          <div className={styles.row}>
            <input
              type="text"
              placeholder="Name"
              name="name"
              className={`${styles.input} ${
                formik.touched.name && formik.errors.name && styles.error
              }`}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <input
              type="text"
              placeholder="Your Email"
              name="email"
              className={`${styles.input} ${
                formik.touched.email && formik.errors.email && styles.error
              }`}
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <button id="inApphudSubscriptionForm" type="submit">
              I'm in!
            </button>
          </div>
          <div className={styles.row}>
            <div className={styles.checkbox}>
              <label htmlFor="agreementId">
                <input
                  type="checkbox"
                  name="agreement"
                  id="agreementId"
                  value={formik.values.agreement}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <span className={styles.checkmark} />
                &nbsp; I have read and understood Apphud{" "}
                <a href="https://legal.apphud.com/privacy" target="_blank">
                  Privacy Policy
                </a>
              </label>
            </div>
          </div>
        </form>*/}
      </div>
      {done && (
        <div className={styles.modal}>
          <div className={styles.container}>
            <label>Thank you! We'll contact you soon!</label>
            <button onClick={() => setDone(false)}>Good!</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InAppSubscriptionForm;
